// services/mealPlanningService.js
import { apiClient } from "./apiClient";

// ---------- GET all ----------
export async function fetchMealPlansApi({ workspaceId, token }) {
  return apiClient(`/mealplanning/workspace/${workspaceId}`, {
    token,
    method: "GET",
  });
}

// ---------- GET favorites ----------
export async function fetchMealFavoritesApi({ workspaceId, token }) {
  return apiClient(`/favorites/workspace/${workspaceId}`, {
    token,
    method: "GET",
  });
}

// ---------- POST ----------
export async function createMealPlanApi({ token, plan }) {
  return apiClient(`/mealplanning`, {
    token,
    method: "POST",
    body: plan,
  });
}

// ---------- PUT ----------
export async function updateMealPlanApi({ token, id, plan }) {
  return apiClient(`/mealplanning/${id}`, {
    token,
    method: "PUT",
    body: plan,
  });
}

// ---------- DELETE ----------
export async function deleteMealPlanApi({ token, id }) {
  return apiClient(`/mealplanning/${id}`, {
    token,
    method: "DELETE",
  });
}
